// Permission constants sourced strictly from /roles/groups response.
// Users permissions (p_u0001..p_u0006) are included in a separate export
// because there is no Users group in /roles/groups, but they exist in role permissions.

export const PERMISSIONS = {
  USERS: {
    GROUP: 'p_u',
    VIEW: 'p_u0001',
    CREATE: 'p_u0002',
    UPDATE: 'p_u0003',
    DELETE: 'p_u0004',
    APPROVE: 'p_u0005',
    MANAGE_DOGS: 'p_u0006',
  },
  ADVERTISEMENTS: {
    GROUP: 'p_ad',
    VIEW: 'p_ad0001',
    CREATE: 'p_ad0002',
    UPDATE: 'p_ad0003',
    DELETE: 'p_ad0004',
  },
  AREAS: {
    GROUP: 'p_ar',
    VIEW: 'p_ar0001',
    CREATE: 'p_ar0002',
    UPDATE: 'p_ar0003',
    DELETE: 'p_ar0004',
  },
  GOVERNORATES: {
    GROUP: 'p_g',
    VIEW: 'p_g0001',
    CREATE: 'p_g0002',
    UPDATE: 'p_g0003',
    DELETE: 'p_g0004',
  },
  DASHBOARD: {
    GROUP: 'p_d',
    VIEW: 'p_d0001',
    UPDATE_RIDE_STATUS: 'p_d0002',
  },
  DOG_BREEDS: {
    GROUP: 'p_db',
    VIEW: 'p_db0001',
    CREATE: 'p_db0002',
    UPDATE: 'p_db0003',
    DELETE: 'p_db0004',
  },
  PRICING: {
    GROUP: 'p_pr',
    VIEW: 'p_pr0001',
    UPDATE: 'p_pr0002',
    DELETE: 'p_pr0003',
  },
  PROMO_CODES: {
    GROUP: 'p_pc',
    VIEW: 'p_pc0001',
    CREATE: 'p_pc0002',
    UPDATE: 'p_pc0003',
    DELETE: 'p_pc0004',
  },
  ROLES: {
    GROUP: 'p_r',
    VIEW: 'p_r0001',
    CREATE: 'p_r0002',
    UPDATE: 'p_r0003',
    DELETE: 'p_r0004',
  },
  RUSH_HOURS: {
    GROUP: 'p_rh',
    VIEW: 'p_rh0001',
    CREATE: 'p_rh0002',
    UPDATE: 'p_rh0003',
    DELETE: 'p_rh0004',
  },
  SETTINGS: {
    GROUP: 'p_s',
    VIEW: 'p_s0001',
    UPDATE: 'p_s0002',
  },
  SUB_ADMINS: {
    GROUP: 'p_sa',
    VIEW: 'p_sa0001',
    CREATE: 'p_sa0002',
    UPDATE: 'p_sa0003',
    DELETE: 'p_sa0004',
  },
  TRANSACTIONS: {
    GROUP: 'p_t',
    VIEW: 'p_t0001',
    CREATE: 'p_t0002',
  },
};

// Backwards compatibility export for places importing USERS_PERMISSIONS
export const USERS_PERMISSIONS = {
  VIEW: PERMISSIONS.USERS.VIEW,
  CREATE: PERMISSIONS.USERS.CREATE,
  UPDATE: PERMISSIONS.USERS.UPDATE,
  DELETE: PERMISSIONS.USERS.DELETE,
  APPROVE: PERMISSIONS.USERS.APPROVE,
  MANAGE_DOGS: PERMISSIONS.USERS.MANAGE_DOGS,
};


